import type { ClientGPSLocation } from '@DigitaleDoerfer/digitale-doerfer-api';

/**
 * Earth radius in meters
 */
export const EARTH_RADIUS = 6_378_137;

export const NULL_GPS_LOCATION: ClientGPSLocation = {
  latitude: 0,
  longitude: 0
};
